import apiClient from '@/services/api/apiClient';
import { buildApiUrl } from '../utils';
import {
  GetAccountCepResponse,
  GetAccountByIdResponse,
  GetAccountAvatarResponse,
  PutAccountAvatarResponse,
  GetAccountTermsResponse,
  GetAccountResponse,
  PutAccountContactResponse,
  GetAccountNotificationAccountResponse,
} from '../response/account';
import { QueryParams } from '@/model/query-params';
import { PutAccountInfoRequest, PutAccountAvatarRequest } from '../request/account';

export class AccountService {
  static getAccount(params?: QueryParams) {
    return apiClient.get<GetAccountResponse>(buildApiUrl('/api/v1/account'), params);
  }

  static getAccountCep(id: string) {
    const url = buildApiUrl('/api/v1/account/cep/:id', { id });
    return apiClient.get<GetAccountCepResponse>(url, undefined);
  }

  static getAccountById(id: string) {
    const url = buildApiUrl('/api/v1/account/:id', { id });
    return apiClient.get<GetAccountByIdResponse>(url, undefined);
  }

  static putAccountDelete(id: string) {
    const url = buildApiUrl('/api/v1/account/:id/delete', { id });
    return apiClient.update<void>(url, undefined);
  }

  static getAccountAvatar(id: string) {
    const url = buildApiUrl('/api/v1/account/:id/avatar', { id });
    return apiClient.get<GetAccountAvatarResponse>(url, undefined);
  }

  static putAccountAvatar(id: string, data: PutAccountAvatarRequest) {
    const url = buildApiUrl('/api/v1/account/:id/avatar', { id });
    return apiClient.updateWithFile<PutAccountAvatarResponse>(url, data);
  }

  static deleteAccountAvatar(id: string) {
    const url = buildApiUrl('/api/v1/account/:id/avatar', { id });
    return apiClient.delete<void>(url, undefined);
  }

  static putAccountInfo(id: string, data: PutAccountInfoRequest) {
    const url = buildApiUrl('/api/v1/account/:id/info', { id });
    return apiClient.update<void>(url, data);
  }

  static putAccountAddress(id: string, data: any) {
    const url = buildApiUrl('/api/v1/account/:id/address', { id });
    return apiClient.update<void>(url, data);
  }

  static putAccountContact(id: string, data: any) {
    const url = buildApiUrl('/api/v1/account/:id/contact', { id });
    return apiClient.update<PutAccountContactResponse>(url, data);
  }

  static getAccountTerms(id: string, key: string) {
    const url = buildApiUrl('/api/v1/account/:id/terms/:key', { id, key });
    return apiClient.get<GetAccountTermsResponse>(url, undefined);
  }

  static putAccountTerms(id: string, key: string, data: any) {
    const url = buildApiUrl('/api/v1/account/:id/terms/:key', { id, key });
    return apiClient.update<void>(url, data);
  }

  static getAccountNotification(id: string, params?: QueryParams) {
    const url = buildApiUrl('/api/v1/account/:id/notification', { id });
    return apiClient.get<GetAccountNotificationAccountResponse>(url, params);
  }

  static putAccountNotificationRead(id: string) {
    const url = buildApiUrl('/api/v1/account/:id/notification/:notification_id/read', { id });
    return apiClient.update<void>(url);
  }

  static putAccountNotificationAllRead(id: string) {
    const url = buildApiUrl('/api/v1/account/:id/notification-all-read', { id });
    return apiClient.update<void>(url);
  }

  static putAccountNotificationClean(id: string) {
    const url = buildApiUrl('/api/v1/account/:id/notification-clean', { id });
    return apiClient.update<void>(url);
  }
}
